import React from 'react';
import { Globe } from 'lucide-react';
import { languages, useLanguage } from '../lib/i18n';

export default function LanguageSelector() {
  const { currentLang, setCurrentLang } = useLanguage();

  return (
    <div className="relative group">
      <select
        value={currentLang}
        onChange={(e) => setCurrentLang(e.target.value)}
        className="appearance-none bg-transparent rounded-md py-1 pl-7 pr-2 cursor-pointer focus:outline-none focus:ring-2 focus:ring-cyan-500 text-white hover:bg-blue-800/30 transition-colors"
        style={{
          minWidth: '6rem'
        }}
        title="Select Language"
      >
        {languages.map((lang) => (
          <option 
            key={lang.code} 
            value={lang.code} 
            className="bg-blue-900 text-sm"
          >
            {lang.name}
          </option>
        ))}
      </select>
      <div className="absolute left-1.5 top-1/2 -translate-y-1/2 pointer-events-none text-white">
        <Globe className="h-3.5 w-3.5" />
      </div>
    </div>
  );
}
